import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { CSSProperties } from "@mui/styles";
import { handleNameTranslation } from "utilities/localesUtilities";
import { EventReportsEntity } from "entities/EventReports/EventReportsEntity";
import { IOption } from "../Dropdown";
import { SegmentFieldVariant, SegmentSelect } from "./SegmentSelect";

interface IAreaFieldProps {
    machineCenterId: number;
    failureTypeId?: number;
    value?: number;
    obligatory?: boolean;
    inlineStyle?: CSSProperties;
    variant?: SegmentFieldVariant;
    placeholder?: string;
    onChange: (areaId: number) => void;
}

/** Controlled area selector reused by the inline table edit and the split modal. */
export const AreaField = ({
    machineCenterId,
    failureTypeId,
    value,
    obligatory = true,
    inlineStyle,
    variant = "inline",
    placeholder,
    onChange,
}: IAreaFieldProps) => {
    const { i18n } = useTranslation();
    const { loading, areas } = EventReportsEntity.GetAreas(machineCenterId, failureTypeId);

    const options: IOption[] = useMemo(
        () =>
            areas.map((area) => ({
                name: handleNameTranslation(i18n.language, area.translation.translation_names),
                id: area.area_id,
            })),
        [areas, i18n.language],
    );

    const currentSelectionInOptions = useMemo(() => options.some((option) => option.id === value), [options, value]);

    return (
        <SegmentSelect
            variant={variant}
            value={value}
            options={options}
            onChange={onChange}
            loading={loading}
            obligatory={obligatory}
            pending={!Boolean(value) || !currentSelectionInOptions}
            placeholder={placeholder}
            inlineStyle={inlineStyle}
        />
    );
};
